// @flow
import * as React from 'react';
import styles from './Placeholder.css';

type Props = {
  editable: boolean,
  onClickAddEstimateGroup: () => void
}

class Component extends React.PureComponent<Props> {

  render () {

    const {
      editable,
      onClickAddEstimateGroup
    } = this.props;

    return (

      <div
        className={styles.wrapper}
      >

        <div className={styles.message}>

          {'This estimate is empty. '}

          {editable && (
            <span>
              <span
                className={styles.addLink}
                onClick={() => onClickAddEstimateGroup()}
                role="presentation"
              >
                {'Add a group'}
              </span>
              {' to get started.'}
            </span>
          )}

        </div>

      </div>

    )
  }
}

export default Component;